module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"main_title":"Publisher recommendations"},"cs":{"main_title":"Doporučení vydavatelé"}}')
  delete Component.options._Ctor
}
